import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import Icon from '@/assets/images/icon/icon_banner_consulting.svg';
import { UiCommon } from '@/common/common';

/**
 * // TODO:
 * 전문가 문의 플로팅 메뉴
 * 임시 처리로 추후 변경 가능
 */
const FloatingBanner = () => {
	const handleScrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	};

	return (
		<div className="floating-banner">
			<div className="inner">
				<div className="box box4">
					<p>
						제품 상담
						<br />
						가입 문의<span>1811-6306</span>
					</p>
				</div>
				<Link className="box box1" to={NAV_PATH.PROMOTION}>
					성장 UP <br />
					프로모션
				</Link>
				<a className="box box6" href={NAV_PATH.BLOG} target="_blank" rel="noopener noreferrer">
					블로그
					<br />
					바로가기
				</a>

				<a
					className="box box3"
					href="/common/stella_intro.pdf"
					target="_blank"
					rel="noopener noreferrer"
					download="스텔라 소개서">
					소개 자료 <br />
					다운로드
				</a>

				<Link className="box box5" to={`${NAV_PATH.FUNCTION.CONVENIENCE}${`#pharosAI`}`}>
					말만해 AI
					<br />
					<span>Beta</span>
				</Link>
			</div>

			<button type="button" className="top-btn" onClick={handleScrollToTop}>
				<span className="blind">맨 위로</span>
			</button>
		</div>
	);
};

export default FloatingBanner;
